export const TOKEN_KEY = 'myorders_token';
export const USER_DETAILS_KEY = 'myorders_user_details';
export const IS_USER_LOGGED_IN_KEY = 'myorders_is_user_logged_in';
export const USER_ACCESS_DATA_KEY='myorders_user_access_data';

export function getJSessionIdCookie(): string | undefined {
    const cookies = window.document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].trim();
        if (cookie.startsWith('JSESSIONID=')) {
            return cookie.substring('JSESSIONID='.length, cookie.length);
        }
    }
    return undefined;
}

export function setToken(token: string): void {
    localStorage.setItem(TOKEN_KEY, token);
}

export function getToken(): string | null {
    return localStorage.getItem(TOKEN_KEY);
}

export function setUserDetails(userDetails: any): void {
    localStorage.setItem(USER_DETAILS_KEY, JSON.stringify(userDetails));
}

export function getUserDetails(): any {
    const userDetails = localStorage.getItem(USER_DETAILS_KEY);
    return userDetails ? JSON.parse(userDetails) : null;
}

export function setIsUserLoggedIn(isLoggedIn: boolean): void {
    localStorage.setItem(IS_USER_LOGGED_IN_KEY, JSON.stringify(isLoggedIn));
}

export function getIsUserLoggedIn(): boolean {
    const isLoggedIn = localStorage.getItem(IS_USER_LOGGED_IN_KEY);
    return isLoggedIn ? JSON.parse(isLoggedIn) : false;
}
export function setUserAccessData(userAccessData: any): void {
    localStorage.setItem(USER_ACCESS_DATA_KEY, JSON.stringify(userAccessData));
}

export function getUserAccessData(): any {
    const userAccessData = localStorage.getItem(USER_ACCESS_DATA_KEY);
    return userAccessData ? JSON.parse(userAccessData) : null;
}
